import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserRequestService } from 'src/app/home/services/user-request.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent {
  step = 0;
  formGroup1AddUser: FormGroup;
  formGroup2AddUser: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userService: UserRequestService,
    private router: Router,
  ) {
    this.formGroup1AddUser = this.fb.group({
      campo1: ['']
    });

    this.formGroup2AddUser = this.fb.group({
      nombres: ['', Validators.required],
      primerApellido: ['', Validators.required],
      segundoApellido: ['', Validators.required],
      rut: ['', Validators.required],
      emailPersonal: ['', [Validators.required, Validators.email]],
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
    });
  }

  isFormValidAddUser(): boolean {
    return this.formGroup1AddUser.valid && this.formGroup2AddUser.valid;
  }

  async guardarAddUser() {
    if (this.isFormValidAddUser()) {
      const request = {
        nombres: this.formGroup2AddUser.value.nombres,
        apellido_paterno: this.formGroup2AddUser.value.primerApellido,
        apellido_materno: this.formGroup2AddUser.value.segundoApellido,
        rut: this.formGroup2AddUser.value.rut,
        usuario_id: this.formGroup2AddUser.value.emailPersonal,
        fecha_inicio: this.formGroup2AddUser.value.fechaInicio,
        fecha_termino: this.formGroup2AddUser.value.fechaFin,
      }
      await this.userService.postUser(request)
        .then((response: any) => {
          if (response) {
            this.router.navigate(['/admin/users']);
          }
        });
    } else {
      alert('Form inválido. Por favor, completa todos los campos.');
    }
  }

  cancelarAddUser() {
    this.router.navigate(['/admin/users']);
  }

}
